import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// Filters live in the query string, so leaving a list for one of its entries and coming back
// restores exactly what was being looked at — and a filtered list can be linked to. Updates
// replace the history entry: typing in a search box is not navigation.
export function useFilterParams(keys) {
  const [params, setParams] = useSearchParams();
  const values = Object.fromEntries(keys.map(key => [key, params.get(key) || '']));

  const setValue = useCallback((key, value) => {
    setParams((previous) => {
      const next = new URLSearchParams(previous);
      if (value) next.set(key, value);
      else next.delete(key);
      return next;
    }, { replace: true });
  }, [setParams]);

  const reset = useCallback(() => {
    setParams((previous) => {
      const next = new URLSearchParams(previous);
      keys.forEach((key) => next.delete(key));
      return next;
    }, { replace: true });
  }, [setParams, keys]);

  return [values, setValue, reset];
}
